const handleFetchProcessingsFulfilled = (state, action) => {
  state.status = 'succeeded';
  // Extract payload data safely
  const payloadData = action?.payload?.data;
  const processingData = payloadData?.data || [];
  if (processingData.length > 0) {
    state.processingList = processingData;
    state.currentPage = payloadData.current_page || 1; 
    state.perPage = payloadData.per_page || 10; 
    state.totalPages = payloadData.last_page || 0; 
    state.totalProcessings = payloadData.total_count || 0; 
    state.lastUpdated = payloadData.last_updated || null;
    state.message = action?.payload?.message || ''; 
  } else {
    state.processingList = []; 
    state.currentPage = 1; 
    state.perPage = 10; 
    state.totalPages = 0; 
    state.totalProcessings = 0; 
    state.lastUpdated = null; 
    state.message = 'No processings found'; 
  }
};


const handleUploadingProcessingFiles = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
};

const handleDeleteProcessingFileFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
};

const handleProcessingStatusList = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
  state.entityProcessingStatuses = action.payload.data || [];
};

const handleProcessingGlobalSatusListFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
  state.processingGlobalStatusList = action.payload.data || [];
};

const updateProcessingGlobalSatusListFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
};

const handleUpdateProcessingStatus = (state, action) => {
  state.status = "succeeded";
  state.message = action.payload.message;
};

const handleUpdateProcessingDetails = (state, action) => {
  state.status = "succeeded";
  state.message = action.payload.message;
}

const handleFetchProcessingLicence = (state, action) => {
  state.status = "succeeded";
  state.message = action.payload.message;
  state.processingLicences = action.payload.data || [];
};

const handleInsuranceTypeList = (state, action) => {
  state.status = "succeeded";
  state.message = action.payload.message;
  state.insuranceTypeList = action.payload.data || [];
};

const handleFetchProcessingDetails = (state, action) => {
  state.status = "succeeded";
  state.message = action.payload.message;
  state.processingDetails = action.payload.data || [];
};

const handleUpdateProcessingDocuments = (state, action) => {
  state.status = "succeeded";
  state.message = action.payload.message;
};

const handleUpdateProcessingFullDetails = (state, action) => {
  state.status = "succeeded";
  state.message = action.payload.message;
};

const handleUpdateProcessinEVisaFulfilled = (state, action) => {
  state.status = "succeeded";
  state.message = action.payload.message;
};

const handleFetchProcessingFiles = (state, action) => {
  state.status = 'succeeded';
  state.processingFilesMessage = action.payload.message;
  const processingFileData = action?.payload?.data?.data || [];
  const paginationInfo = action?.payload?.data;
  
  if (processingFileData.length > 0) {
    state.processingFiles = processingFileData;
    state.processingFilesCurrentPage = paginationInfo.current_page || 1; 
    state.processingFilesPerPage = paginationInfo.per_page || 10; 
    state.processingFilesTotalPages = paginationInfo.last_page || 0; 
    state.processingFilesTotal = paginationInfo.total || 0; 
    state.processingFilesLastUpdated = paginationInfo.last_update || null;
  } else {
    state.processingFiles = []; 
    state.processingFilesCurrentPage = 1; 
    state.processingFilesPerPage = 10; 
    state.processingFilesTotalPages = 0; 
    state.processingFilesTotal = 0; 
    state.processingFilesLastUpdated = ''; 
  }
};

const handleFetchProcessingActivityFulfilled = (state, action) => {
  state.status = "succeeded";
  state.activityLogList = action.payload;
};

const handleMedicalDocumentViewFulfilled = (state, action) => {
  state.status = "succeeded";
  state.medicalDocument = action.payload.data;
}

const handleVisaDocumentDetailsFulfilled = (state, action) => {
  state.status = "succeeded";
  state.visaDocument = action.payload.data;
}

const handleMedicalDocumentStatusListFulfilled = (state, action) => {
  state.status = "succeeded";
  state.medicalDocumentStatusList = action.payload.data;
}

const handleMedicalDocumentStatusChangeFulfilled = (state) => {
  state.status = "succeeded";
}

const handleInsuranceDocumentStatusListFulfilled = (state, action) => {
  state.status = "succeeded";
  state.insuranceDocumentStatusList = action.payload.data;
}

const handleInsuranceDocumentStatusChangeFulfilled = (state) => {
  state.status = "succeeded";
}

const handleMedicalDocumentSaveFulfilled = (state) => {
  state.status = "succeeded";
}

const handleMedicalDocumentDeleteFulfilled = (state) => {
  state.status = "succeeded";
}

const handleInsuranceDocumentSaveFulfilled = (state) => {
  state.status = "succeeded";
}

const handleInsuranceDocumentViewFulfilled = (state, action) => {
  state.status = "succeeded";
  state.insuranceDocument = action.payload.data;
}

const handleUpdateMasterFormFulfilled = (state) => {
  state.status = "succeeded";
}

const handleGetMasterDetailsFulfilled = (state, action) => {
  state.status = "succeeded";
  state.masterFormDetails = action.payload.data;
}

const handleFetchProfileDetailsFulfilled = (state) => {
  state.status = "succeeded";
}

const handleFetchLastPullDetailsFulfilled = (state) => {
  state.status = "succeeded";
}

const handleProcessingFollowUpListFulfilled = (state, action) => {
  state.status = "succeeded";
  state.processingFollowUpList = action.payload.data;
}

const handleSaveFollowUpFulfilled = (state) => {
  state.status = "succeeded";
}

const handleDeleteFollowUpFulfilled = (state) => {
  state.status = "succeeded";
}

const handlePreDepartureUploadMedFileFulfilled = (state) => {
  state.status = "succeeded";
}

const handlePreDepartureMedicalDocStatusList = (state, action) => {
  state.status = "succeeded";
  state.preDepartureMedicalDocStatuses = action.payload.data;
}

const handlePreDepartureMedicalDocChangeStatus = (state) => {
  state.status = "succeeded";
}

const handlePreDepartureMedicalDocFileDelete = (state) => {
  state.status = "succeeded";
}

const handlePreDepartureOtherDocStatusListFulfilled = (state, action) => {
  state.status = "succeeded";
  state.preDepartureOtherDocStatus = action.payload.data;
}

const handlePreDepartureOtherDocChangeStatus = (state) => {
  state.status = "succeeded";
}

const handleVisaShareUpdateFulfilled = (state) => {
  state.status = "succeeded";
}

const handleMedicalShareUpdateFulfilled = (state) => {
  state.status = "succeeded";
}

const handleDeploymentShareUpdateFulfilled = (state) => {
  state.status = "succeeded";
}

const handlePreDepartureDocumentViewFulfilled = (state, action) => {
  state.status = "succeeded";
  state.preDepartureDocument = action.payload.data;
}

const handleEvisaDocumentStatusList = (state, action) => {
  state.status = "succeeded";
  state.eVisaDocumentStatusList = action.payload.data;
}

const handleEvisaDocumentStatusChange = (state) => {
  state.status = "succeeded";
}

const handleDeploymentDocumentViewFulfilled = (state, action) => {
  state.status = "succeeded";
  state.deploymentDocument = action.payload.data;
}

const handleDeploymentUpdateDHLContract = (state) => {
  state.status = "succeeded";
}

const handleDeploymentUpdateFlightDetails = (state) => {
  state.status = "succeeded";
}

const handleDeploymentUpdateHKIDDetails = (state) => {
  state.status = "succeeded";
}

const handleDeploymentUpdatePickupDetails = (state) => {
  state.status = "succeeded";
}

const handleDeploymentStatusList = (state, action) => {
  state.status = "succeeded";
  state.deploymentStatuses = action.payload.data;
}

const handleUpdateProcessingVisaAuth = (state) => {
  state.status = "succeeded";
}

const handleActivateProcessingFulfilled = (state) => {
  state.status = "succeeded";
}

const handleActivateProcessingGroup1And2Fulfilled = (state) => {
  state.status = "succeeded";
}

const handleChagneProcessingCsFulfilled = (state) => {
  state.status = "succeeded"; 
}

const handleUpdateID988bFormDataFulfilled = (state) => {
  state.status = "succeeded";
}

const handleUpdateID988aFormDataFulfilled = (state) => {
  state.status = "succeeded";
}

const handleUpdateID407FormDataFulfilled = (state) => {
  state.status = "succeeded";
}

const handleDownloadEditablePdfFulfilled = (state) => {
  state.status = "succeeded";
}

const handleDownloadNonEditablePdfFulfilled = (state) => {
  state.status = "succeeded";
}

export {
  handleFetchProcessingsFulfilled,
  handleUploadingProcessingFiles,
  handleFetchProcessingFiles,
  handleDeleteProcessingFileFulfilled,
  handleProcessingStatusList,
  handleUpdateProcessingStatus,
  handleUpdateProcessingDetails,
  handleFetchProcessingLicence,
  handleInsuranceTypeList,
  handleFetchProcessingDetails,
  handleUpdateProcessingDocuments,
  handleUpdateProcessingFullDetails,
  handleUpdateProcessinEVisaFulfilled,
  handleFetchProcessingActivityFulfilled,
  handleMedicalDocumentViewFulfilled,
  handleMedicalDocumentStatusChangeFulfilled,
  handleMedicalDocumentSaveFulfilled,
  handleMedicalDocumentDeleteFulfilled,
  handleInsuranceDocumentSaveFulfilled,
  handleInsuranceDocumentViewFulfilled,
  handleMedicalDocumentStatusListFulfilled,
  handleInsuranceDocumentStatusListFulfilled,
  handleInsuranceDocumentStatusChangeFulfilled,
  handleUpdateMasterFormFulfilled,
  handleGetMasterDetailsFulfilled,
  handleFetchProfileDetailsFulfilled,
  handleFetchLastPullDetailsFulfilled,
  handleProcessingFollowUpListFulfilled,
  handleSaveFollowUpFulfilled,
  handleDeleteFollowUpFulfilled,
  handleProcessingGlobalSatusListFulfilled,
  updateProcessingGlobalSatusListFulfilled,
  handleVisaDocumentDetailsFulfilled,
  handlePreDepartureUploadMedFileFulfilled,
  handlePreDepartureMedicalDocStatusList,
  handlePreDepartureMedicalDocChangeStatus,
  handlePreDepartureMedicalDocFileDelete,
  handlePreDepartureOtherDocStatusListFulfilled,
  handlePreDepartureOtherDocChangeStatus,
  handlePreDepartureDocumentViewFulfilled,
  handleVisaShareUpdateFulfilled,
  handleMedicalShareUpdateFulfilled,
  handleEvisaDocumentStatusList,
  handleEvisaDocumentStatusChange,
  handleDeploymentDocumentViewFulfilled,
  handleDeploymentUpdateDHLContract,
  handleDeploymentUpdateFlightDetails,
  handleDeploymentUpdateHKIDDetails,
  handleDeploymentUpdatePickupDetails,
  handleDeploymentStatusList,
  handleUpdateProcessingVisaAuth,
  handleDeploymentShareUpdateFulfilled,
  handleActivateProcessingFulfilled,
  handleActivateProcessingGroup1And2Fulfilled,
  handleChagneProcessingCsFulfilled,
  handleUpdateID988bFormDataFulfilled,
  handleUpdateID988aFormDataFulfilled,
  handleUpdateID407FormDataFulfilled,
  handleDownloadEditablePdfFulfilled,
  handleDownloadNonEditablePdfFulfilled
};